export default "__VITE_ASSET__DVCfQCCQ__"